/**
 * A factory for creating error actions. Figured these would be generally similar across
 * the board so its better to have it in one place instead of being used in each actions file
 * @param type: The constant ACTION_TYPE string
 * @param error: The error
 * @param other: An object of any other params you want available in the action object
 * @returns {{type: string, error: Error, ...spread of whatever else you sent}}
 */

export function errorActionFactory(type, error, other = {}) {
    return {
        type,
        error,
        ...other
    };
}



// WEBPACK FOOTER //
// ./src/helpers/errors.js